import * as React from "react";
const SvgExpand = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M21 10h-2V6.5L6.5 19H10v2H3v-7h2v3.672L17.672 5H14V3h7v7Z" fill="var(--icon-primary)" /></svg>;
export default SvgExpand;